import { render, staticRenderFns } from "./domRF.vue?vue&type=template&id=d4bfe44c&scoped=true&"
import script from "./domRF.vue?vue&type=script&lang=js&"
export * from "./domRF.vue?vue&type=script&lang=js&"
import style0 from "./domRF.vue?vue&type=style&index=0&id=d4bfe44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bfe44c",
  null
  
)

export default component.exports